export enum EEntities {
    users = 'users',
    admins = 'admins',
    auth = 'auth',
    app = 'app',
    pendingTasks = 'pendingTasks',
}

export type TMessage<T = string> = (args?: T) => string;

export type TMessages = {
    [EEntities.users]: {
        onEkycConfirm: TMessagesAsyncStates;
        onEkycReject: TMessagesAsyncStates;
        onUnblock: TMessagesAsyncStates;
        onPinReset: TMessagesAsyncStates;
    };
    [EEntities.admins]: TMessagesCrudStates;
    [EEntities.auth]: {
        onSignIn: {
            onSuccess: TMessage;
            onErrorSwitch: TMessage<EMessagesAuthErrorResponseTypes>;
            onWrongCredentials: TMessage;
            onAnyOtherError: TMessage;
        };
    };
    [EEntities.app]: {
        onNetworkError: TMessage;
        onAnyOtherError: TMessage;
    };
    [EEntities.pendingTasks]: {
        onCreatePendingTask: {
            onSuccess: TMessage<string>;
        };
    };
} & {
    [index in EEntities]: unknown;
};

export enum EMessagesAsyncStateTypes {
    onSuccess = 'onSuccess',
    onError = 'onError',
}

export type TMessagesAsyncStates = {
    [index in EMessagesAsyncStateTypes]?: TMessage;
};

export enum EMessagesCrudTypes {
    add = 'add',
    edit = 'edit',
    del = 'del',
    get = 'get',
}

export type TMessagesCrudStates = {
    [index in EMessagesCrudTypes]?: {
        [index in EMessagesAsyncStateTypes]?: TMessage;
    };
};

export enum EMessagesAuthErrorResponseTypes {
    unauthorized = 'unauthorized',
}
